export const TRAVELER_INFO_TITLE = "Step 1: Add traveler";
export const TRAVELER_INFO_TITLE_SUBHEADING =
  "Select the primary traveler for this hotel reservation.";
export const TRAVELER_INFO_SUBTITLE =
  "Your booking will be reserved under the primary traveler’s name.";
export const FREQUENT_FLYER_TITLE = "Frequent flyer details";
export const ADDITIONAL_INFO_TITLE = "Additional information";
export const ADULT_TITLE = "Adult";
export const CHILD_TITLE = "Child";
export const INFANT_SEAT_TITLE = "Infant";
export const INFANT_LAP_TITLE = "Infant";
export const UPDATE_TEXT = "Updating passengers";
export const VALIDATE_TEXT = "Validating passengers";
export const ADD_TRAVELERS_TEXT = "Add primary traveler";
export const ADD_TRAVELERS_TEXT_UPDATED = "Select or add traveler";
export const ADD_TRAVELER_INFO_TEXT = "Add traveler information";
export const TRAVELER_INFO_TEXT = "Add primary traveler";
export const ADD_TRAVELER_ERROR_MESSAGE =
  "Add or choose one traveler to continue.";
export const WHOS_CHECKING_IN_TITLE = "Who’s checking in?";
export const WHOS_CHECKING_IN_HEADING_V1 = "2. Who’s checking in?";

export const HOTEL_TRAVELER_NOTICE = "Select 1 primary traveler to continue.";

export const MOBILE_CONTINUE_TEXT = "Enter contact information";

// corporate
export const COMPLETE_PROFILE_TITLE = "Complete traveler profile";
export const COMPLETE_PROFILE_SUBTITLE =
  "Please make sure all the information added matches the government issued ID for this traveler as this will be applied to travel bookings moving forward. Traveler information will be accessible to all Admins.";

export const CONTINUE_TEXT = "Continue";

export const SELECTED_PAX_DIFFERS_FROM_SEARCHED_BANNER_TEXT_MOBILE = (
  isFewer: boolean
) =>
  `You’ve added ${
    isFewer ? "fewer" : "more"
  } travelers than originally searched for. The total price will update after you complete the contact information step.`;
